export class ExpirationDateUtil {

  public static takeMonthFromExpirationDate(expirationDate: string) {
    const expirationDateTrim = expirationDate.replace(/\s/g, "");
    const expirationDateSplit = expirationDateTrim.split('/');
    return expirationDateSplit[0];
  }

  public static takeYearFromExpirationDate(expirationDate: string) {
    const expirationDateTrim = expirationDate.replace(/\s/g, "");
    const expirationDateSplit = expirationDateTrim.split('/');
    return expirationDateSplit[1];
  }
}

